/* ==========================================================================
   Bundle Qty Selector (Shopify + Be Yours)
   Goal:
   - Selecting 3/5/10 uses the BUNDLE PRODUCT variant (different price)
   - Adds bundle variant with quantity = 1
   - Drawer opens (cart:refresh open)
   - Selecting 1 uses the normal product variant (quantity = 1)
   ========================================================================== */

(function () {
  "use strict";

  function formatEuroFromCents(priceInCents) {
    const euros = Math.floor(priceInCents / 100);
    const cents = String(priceInCents % 100).padStart(2, "0");
    return { euros, cents };
  }

  function updateThemePrice(priceInCents) {
    const { euros, cents } = formatEuroFromCents(priceInCents);

    document.querySelectorAll(".price__regular .price-item--regular").forEach((el) => {
      const bdi = el.querySelector("bdi");
      const html =
        '<span class="visually-hidden">&euro;</span>€\u00a0' +
        euros +
        ',<span>' +
        cents +
        "</span>";

      if (bdi) bdi.innerHTML = html;
      else el.innerHTML = html;
    });
  }

  function formatSaving(savingInCents) {
    return (savingInCents / 100).toFixed(2).replace(".", ",");
  }

  function openCartDrawer() {
    document.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true,
        detail: { open: true },
      })
    );
  }

  function addVariantToCart(variantId, quantity, properties) {
  return fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      items: [{
        id: parseInt(variantId, 10),
        quantity: parseInt(quantity, 10),
        properties: properties || {}
      }],
    }),
  }).then((res) => {
    if (!res.ok) throw new Error("cart/add.js failed: " + res.status);
    return res.json();
  });
}

  function findSectionScope(el) {
    return el.closest(".shopify-section") || el.closest("[data-section-id]") || document;
  }

  function bindBundleSelector(selector) {
    if (!selector || selector.dataset.bundleBound === "1") return;
    selector.dataset.bundleBound = "1";

    const section = findSectionScope(selector);

    const options = selector.querySelectorAll(".bundle-qty-option");
    const qtyDisplay = selector.querySelector(".bundle-qty-selector__qty-display");
    const savingsDisplay = selector.querySelector(".bundle-qty-selector__savings");

    // This is the variant that should be added on ATC
    let activeVariantId = null;

    function applyOption(option) {
      options.forEach((o) => o.classList.remove("bundle-qty-option--active"));
      option.classList.add("bundle-qty-option--active");

      const input = option.querySelector("input");
      if (input) input.checked = true;

      const qty = parseInt(option.dataset.qty || "1", 10);
      const price = parseInt(option.dataset.price || "0", 10);
      const saving = parseInt(option.dataset.saving || "0", 10);
      const variantId = option.dataset.variant || null;

      if (qtyDisplay) qtyDisplay.textContent = String(qty);

      if (savingsDisplay) {
        if (saving > 0) savingsDisplay.textContent = "Du sparst " + formatSaving(saving) + "\u00a0€";
        else savingsDisplay.textContent = "";
      }

      if (!Number.isNaN(price) && price > 0) updateThemePrice(price);

      activeVariantId = variantId;

      console.log("[Bundle] Selected qty:", qty, "-> will add variant:", activeVariantId);
    }

    // preselect
    const pre =
      selector.querySelector(".bundle-qty-option--active") ||
      selector.querySelector(".bundle-qty-option input:checked")?.closest(".bundle-qty-option") ||
      options[0];

    if (pre) applyOption(pre);

    options.forEach((option) => {
      option.addEventListener("click", function () {
        applyOption(option);
      });
    });

    // CAPTURE listener: block theme ATC and add OUR chosen variant instead
    // We bind once per section to avoid duplicates
    if (section.dataset.bundleAtcBound === "1") return;
    section.dataset.bundleAtcBound = "1";

    section.addEventListener(
      "click",
      function (e) {
        const addBtn = e.target.closest('button[name="add"], [data-add-to-cart]');
        if (!addBtn) return;

        // Find the selector that belongs to this addBtn (same section, nearest)
        const localSelector =
          addBtn.closest(".shopify-section")?.querySelector(".bundle-qty-selector") ||
          section.querySelector(".bundle-qty-selector");

        if (!localSelector) return;

        const active =
          localSelector.querySelector(".bundle-qty-option--active") ||
          localSelector.querySelector(".bundle-qty-option input:checked")?.closest(".bundle-qty-option");

        const vid = active?.dataset?.variant;
        if (!vid) return; // let theme handle normally

        // Stop theme from adding the normal product
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();

        const oldDisabled = addBtn.disabled;
        addBtn.disabled = true;

        // IMPORTANT: add chosen variant as quantity 1 (bundle already includes 3/5/10)
        // --- Bundle Daten aus der aktiven Option holen ---
const saving = parseInt(active?.dataset?.saving || "0", 10);
const qty = parseInt(active?.dataset?.qty || "1", 10);
const basePrice = parseInt(localSelector?.dataset?.basePrice || "0", 10);

// Prozent berechnen
let discountPercent = 0;
if (qty > 1 && basePrice > 0 && saving > 0) {
  discountPercent = Math.round((saving * 100) / (basePrice * qty));
}

// Jetzt Bundle mit Properties hinzufügen
addVariantToCart(vid, 1, {
  "_bundle_qty": String(qty),
  "_bundle_saving_cents": String(saving),
  "_bundle_discount_percent": String(discountPercent)
})
.then(() => {
  openCartDrawer();
})
          .catch((err) => {
            console.error("[Bundle] Failed adding selected variant. Falling back.", err);
            // fallback: submit closest form
            const form = addBtn.closest("form");
            if (form) {
              try { form.submit(); } catch (_) {}
            }
          })
          .finally(() => {
            addBtn.disabled = oldDisabled;
          });
      },
      true
    );
  }

  function init() {
    document.querySelectorAll(".bundle-qty-selector").forEach(bindBundleSelector);
  }

  document.addEventListener("page:loaded", init);
  document.addEventListener("DOMContentLoaded", init);
  document.addEventListener("shopify:section:load", init);

  const obs = new MutationObserver(() => init());
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
